// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLayout_root__2pQhz","menu":"MainLayout_menu__3jTr0","logout":"MainLayout_logout__3tPfm","content":"MainLayout_content__2t0tF"};